export default __webpack_public_path__ + "static/media/e1.b04d4009.jpg";